function setBrandHover(){
    setTimeout(() => {
        const vendorContainer = document.querySelector(".m-header__menu .custom-header-brand");
        const headerVendorMenu = document.querySelector("#custom-brands-grid-header");
        const headerVendorMenuLetter = document.querySelector("#custom-brands-letters-header");
        const headerVendorMenuLetterMobile = document.querySelector("#custom-brands-letters-mobile");
        
        // Try multiple selectors for mobile container
        let mobileVendorContainer = document.querySelector("#m-menu-drawer .custom-brand-button .gm-html-inner");
        
        // If first selector doesn't work, try a simpler one
        if (!mobileVendorContainer) {
            mobileVendorContainer = document.querySelector("#m-menu-drawer .gm-html-inner");
        }
        
        // Move desktop letter navigation
        if(vendorContainer && headerVendorMenuLetter){
            vendorContainer.appendChild(headerVendorMenuLetter);
            console.log('Desktop letter menu moved');
        } else {
            console.log('Missing elements for desktop letter menu:', {vendorContainer, headerVendorMenuLetter});
        }

        // Move desktop brand grid
        if(vendorContainer && headerVendorMenu){
            vendorContainer.appendChild(headerVendorMenu);
            // console.log('Desktop brand grid moved');
        } else {
            console.log('Missing elements for desktop brand grid:', {vendorContainer, headerVendorMenu});
        }

        // Move mobile letter navigation
        if(mobileVendorContainer && headerVendorMenuLetterMobile) {
            mobileVendorContainer.appendChild(headerVendorMenuLetterMobile);
            // console.log('Mobile letter menu moved');
        } else {
            console.log('Missing elements for mobile letter menu:', {mobileVendorContainer, headerVendorMenuLetterMobile});
        }
    }, 3000);
}

function moveDisponibilityButton(){
    setTimeout(() => {
        const verifyButton = document.getElementById("location-checker-btn");
        const statusBlock = document.querySelector('.main-product__block-inventory_status');
        
        if(verifyButton && statusBlock){
            statusBlock.appendChild(verifyButton);
        } else {
            console.log('Missing elements:', {verifyButton, statusBlock});
        }
    }, 1000);
}

function addContainerSubMenu(){
    setTimeout(() => {
        const subMenuSelector = document.querySelectorAll('ul.gm-menu>li.gm-level-0>div');
        const subMenuLength = subMenuSelector.length
        console.log({subMenuLength})
        subMenuSelector.forEach(subMenu => {
            subMenu.classList.add('custom-container-menu')
        })
    }, 1000);
}

function translateTags() {
    if (Shopify.locale == 'fr') { return }

    const labelTranslations = {
        "NOUVEAUTÉ": "New",
        "SOLDE": "Sale",
        "VENTE D'ENTREPÔT": "Warehouse sale",
        "MEILLEUR VENDEUR": "Best seller",
    };

    const colorTranslations = {
        "Argent gris": "Silver Grey",
        "Argent gris-2": "Silver Grey-2",
        "Argent gris-3": "Silver Grey-3",
        "Aucune": "None",
        "Aucune-2": "None-2",
        "Aucune-3": "None-3",
        "Autres couleurs": "Other colors",
        "Autres couleurs-2": "Other colors-2",
        "Autres couleurs-3": "Other colors-3",
        "Beige": "Beige",
        "Beige-2": "Beige-2",
        "Beige-3": "Beige-3",
        "Blanc": "White",
        "Blanc-2": "White-2",
        "Blanc-3": "White-3",
        "Bleu": "Blue",
        "Bleu-2": "Blue-2",
        "Bleu-3": "Blue-3",
        "BORDO": "BORDO",
        "BORDO-2": "BORDO-2",
        "BORDO-3": "BORDO-3",
        "Bourgogne": "Burgundy",
        "Bourgogne-2": "Burgundy-2",
        "Bourgogne-3": "Burgundy-3",
        "Brun": "Brown",
        "Brun-2": "Brown-2",
        "Brun-3": "Brown-3",
        "Caramel": "Camel",
        "Caramel-2": "Camel-2",
        "Caramel-3": "Camel-3",
        "CHARCOAL": "CHARCOAL",
        "CHARCOAL-2": "CHARCOAL-2",
        "CHARCOAL-3": "CHARCOAL-3",
        "Cognac": "Cognac",
        "Cognac-2": "Cognac-2",
        "Cognac-3": "Cognac-3",
        "Cordovan": "Cordovan",
        "Cordovan-2": "Cordovan-2",
        "Cordovan-3": "Cordovan-3",
        "Grey & pink": "Black & gray",
        "Grey & pink-2": "Black & gray-2",
        "Grey & pink-3": "Black & gray-3",
        "Gris & rose": "Grey & pink",
        "Gris & rose-2": "Grey & pink-2",
        "Gris & rose-3": "Grey & pink-3",
        "Gris Pâle": "Light gray",
        "Gris Pâle-2": "Light gray-2",
        "Gris Pâle-3": "Light gray-3",
        "Jaune - Orange": "Yellow orange",
        "Jaune - Orange-2": "Yellow orange-2",
        "Jaune - Orange-3": "Yellow orange-3",
        "Marine": "Marine",
        "Marine-2": "Marine-2",
        "Marine-3": "Marine-3",
        "Mauve": "Purple",
        "Mauve-2": "Purple-2",
        "Mauve-3": "Purple-3",
        "Métallique Doré": "Metallic Gold",
        "Métallique Doré-2": "Metallic Gold-2",
        "Métallique Doré-3": "Metallic Gold-3",
        "Multi": "Multi",
        "Multi-2": "Multi-2",
        "Multi-3": "Multi-3",
        "Neutre": "Neutral",
        "Neutre-2": "Neutral-2",
        "Neutre-3": "Neutral-3",
        "Noir": "Black",
        "Noir-2": "Black-2",
        "Noir-3": "Black-3",
        "Rose": "Pink",
        "Rose-2": "Pink-2",
        "Rose-3": "Pink-3",
        "Rouge": "Red",
        "Rouge-2": "Red-2",
        "Rouge-3": "Red-3",
        "Tan": "Tan",
        "Tan-2": "Tan-2",
        "Tan-3": "Tan-3",
        "Taupe": "Taupe",
        "Taupe-2": "Taupe-2",
        "Taupe-3": "Taupe-3",
        "Vernis noir": "Black varnish",
        "Vernis noir-2": "Black varnish-2",
        "Vernis noir-3": "Black varnish-3",
        "Vert/Kaki": "Green khaki",
        "Vert/Kaki-2": "Green khaki-2",
        "Vert/Kaki-3": "Green khaki-3",
}

    const typeTranslations = {
        "Ballerine": "Ballet flats",
        "Base en caoutchouc": "Rubber base",
        "Base de caoutchouc": "Rubber base",
        "Botillons": "Ankle boots",
        "Bottillon": "Short boots",
        "Bottes de pluie": "Rain boots",
        "Bottes longues": "Tall boots",
        "Bottes mi-jambes": "Mid-calf boots",
        "Bottillons": "Booties",
        "Compensées": "Wedges",
        "Crampons": "Spikes",
        "De marche": "Walking shoes",
        "Fermé": "Closed",
        "Imperméables": "Waterproof",
        "Loafer": "Loafer",
        "Mule": "Mule",
        "Ouvertes": "Open",
        "Talons bas": "Low heels",
        "Talons hauts": "High heels",
        "Talons moyens": "Medium heels",
        "Botte a crampon": "Spiked boots",
        "Chaussures décontractées": "Casual shoes",
        "Chaussures imperméables": "Waterproof shoes",
        "Doublé laine de mouton": "Wool boots",
        "Doublé laine synthétique": "Warm boots",
        "Gore-tex / thinsulte": "Gore-tex / Thinsulate",
        "Habillées avec lacets": "Dress shoes with laces",
        "Habillées sans lacets": "Dress shoes without laces",
        "Pantouffles": "Slippers",
        "Sandales": "Sandals",
        "Bottes d'hiver": "Winter boots",
        "Bottines": "Ankle boots",
        "Bébé fille": "Toddler girl caps",
        "Bébé garçon": "Toddler boy caps",
        "Bébé filles": "Toddler girl hats",
        "Bébé garcons": "Toddler boy hats",
        "Chaussures": "Shoes",
        "Clé crampon": "Spike wrench",
        "Crampon": "Spike",
        "Enfant fille": "Girl caps",
        "Enfant filles": "Girl hats",
        "Enfant garcons": "Boy hats",
        "Enfant garçon": "Boy caps",
        "Entretien": "Shoe care",
        "Femme": "Women",
        "Feutres bébé": "Soles for babies",
        "Feutres enfants": "Soles for kids",
        "Fille": "Girls",
        "Garcon": "Boys",
        "Homme": "Men",
        "Mouton": "Sheep",
        "Pantouffle": "Slippers",
        "Porte-monnaie": "Wallets",
        "Sac a dos": "Backpacks",
        "Sacs de taille": "Waist bags",
        "Sacs sport": "Sports bags",
        "Étuis a crayons": "Pencil cases",
        "Sacs à main": "Handbags",
        "Semelle": "Insoles",
        "Ballerine": "Ballet flats",
        "Base en caoutchouc": "Rubber base",
        "Base de caoutchouc": "Rubber base",
        "Botillons": "Ankle boots",
        "Bottillon": "Short boots",
        "Bottes de pluie": "Rain boots",
        "Chaussures talons hauts pour femme": "High heel shoes for women",
        "Chaussures talons moyens pour femme": "Mid heel shoes for women",
        "Chaussures talons bas pour femme": "Low heel shoes for women",
        "Chaussures compensées pour femme": "Platform shoes for women",
        "Chaussures loafer pour femme": "Loafer shoes for women",
        "Chaussures ballerine pour femme": "Ballet flat shoes for women",
        "Chaussures marche pour femme": "Walking shoes for women",
        "Chaussures mule pour femme": "Mule shoes for women",
        "Chaussures imperméables pour femme": "Waterproof shoes for women",
        "Sandales compensées pour femme": "Platform sandals for women",
        "Sandales talons hauts pour femme": "High heel sandals for women",
        "Sandales talons moyens pour femme": "Mid heel sandals for women",
        "Sandales talons bas pour femme": "Low heel sandals for women",
        "Sandales marche pour femme": "Walking sandals for women",
        "Bottes hiver crampons pour femme": "Winter crampons boots for women",
        "Bottes hiver caoutchouc pour femme": "Winter rubber boots for women",
        "Bottes hiver longues pour femme": "Long winter boots for women",
        "Bottes hiver mi-jambes pour femme": "Mid-calf winter boots for women",
        "Bottes hiver bottillons pour femme": "Winter ankle boots for women",
        "Bottes automne bottillons pour femme": "Fall ankle boots for women",
        "Bottes automne mi-jambes pour femme": "Mid-calf fall boots for women",
        "Bottes automne longues pour femme": "Long fall boots for women",
        "Bottes automne pluie pour femme": "Fall rain boots for women",
        "Bottes imperméables pour femme": "Waterproof boots for women",
        "Pantoufles fermées pour femme": "Closed slippers for women",
        "Chaussures décontractées pour homme": "Casual shoes for men",
        "Chaussures habillé avec lacets pour homme": "Dress shoes with laces for men",
        "Chaussures habillé sans lacets pour homme": "Dress shoes without laces for men",
        "Chaussures imperméables pour homme": "Waterproof shoes for men",
        "Sandales pour homme": "Sandals for men",
        "Pantoufles pour homme": "Slippers for men",
        "Bottes crampons pour homme": "Crampons boots for men",
        "Bottes double laine mouton pour homme": "Double sheep wool boots for men",
        "Bottes double laine synthétiques pour homme": "Double synthetic wool boots for men",
        "Bottes Gore-Tex / Thinsulate pour homme": "Gore-tex / thinsulate boots for men",
        "Bottes caoutchouc pour homme": "Rubber boots for men",
        "Bottillon pour homme": "Short boots for men",
        "Bottes hiver bébé garçon": "Winter boots baby boy",
        "Bottes automne bébé garçon": "Fall boots baby boy",
        "Sandales bébé garçon": "Sandals baby boy",
        "Espadrilles / chaussures bébé garçon": "Sneakers / shoes baby boy",
        "Bottes de pluie bébé garçon": "Rain boots baby boy",
        "Pantoufles bébé garçon": "Slippers baby boy",
        "Bottines bébé garçon": "Booties baby boy",
        "Bottes hiver bébé fille": "Winter boots baby girl",
        "Bottes automne bébé fille": "Fall boots baby girl",
        "Sandales bébé fille": "Sandals baby girl",
        "Espadrilles / chaussures bébé fille": "Sneakers / shoes baby girl",
        "Bottes de pluie bébé fille": "Rain boots baby girl",
        "Pantoufles bébé fille": "Slippers baby girl",
        "Bottines bébé fille": "Booties baby girl",
        "Sport bébé fille": "Sport baby girl",
        "Bottes hiver garçon": "Winter boots boy",
        "Bottes automne garçon": "Fall boots boy",
        "Sandales garçon": "Sandals boy",
        "Espadrilles / chaussures garçon": "Sneakers / shoes boy",
        "Bottes de pluie garçon": "Rain boots boy",
        "Pantoufles garçon": "Slippers boy",
        "Sport garçon": "Sport boy",
        "Bottes hiver fille": "Winter boots girl",
        "Bottes automne fille": "Fall boots girl",
        "Sandales fille": "Sandals girl",
        "Espadrilles / chaussures fille": "Sneakers / shoes girl",
        "Bottes de pluie fille": "Rain boots girl",
        "Pantoufles fille": "Slippers girl",
        "Sport fille": "Sport girl",
        "Entretien chaussures": "Shoe care",
        "Lacets": "Laces",
        "Clé crampon": "Crampon key",
        "Crampon": "Crampon",
        "Semelles mouton": "Sheep wool insoles",
        "Semelles feutres bébé": "Felt insoles baby",
        "Semelles feutres enfants": "Felt insoles children",
        "Semelles": "Insoles",
        "Sacs à main": "Handbags",
        "Sacs à dos": "Backpacks",
        "Sacs de taille": "Waist bags",
        "Sacs sport": "Sport bags",
        "Étuis à crayons": "Pencil cases",
        "Boîtes à lunch": "Lunch boxes",
        "Porte-monnaie": "Wallets",
        "Bas pour femme": "Socks for women",
        "Bas pour homme": "Socks for men",
        "Bas fille": "Socks girl",
        "Bas garçon": "Socks boy",
        "Casquettes bébé fille": "Caps baby girl",
        "Casquettes bébé garçon": "Caps baby boy",
        "Casquettes enfant fille": "Caps girl child",
        "Casquettes enfant garçon": "Caps boy child",
        "Tuques bébé garçon": "Beanie hats baby boy",
        "Tuques bébé fille": "Beanie hats baby girl",
        "Tuques enfant fille": "Beanie hats girl child",
        "Tuques enfant garçon": "Beanie hats boy child",
        "Tuques pour femme": "Beanie hats for women",
    };

    let attempts = 0;
    const maxAttempts = 9;

    function attemptTranslation() {
        const tagsToTranslate = document.querySelectorAll('.snize-search-results-content .snize-thumbnail-wrapper .snize-product-label');
        const typeToTranslate = document.querySelectorAll('.snize-search-results-content .snize-item .snize-attribute');
        const typeCardToTranslate = document.querySelectorAll('.swiper-slide .m-product-card .custom-product-card-type');
        const colorToTranslate = document.querySelectorAll('.snize-search-results-content .snize-item .snize-options-box .snize-color-swatch');
        const colorTooltipToTranslate = document.querySelectorAll('.m-product-card__info .m-product-option .m-tooltip__content');
        
        if (tagsToTranslate.length > 0 && typeToTranslate.length > 0 && colorToTranslate.length > 0) {
            // Found elements, translate them
            tagsToTranslate.forEach(tag => {
                const text = tag.innerText.trim();
                if (labelTranslations[text]) {
                    tag.innerText = labelTranslations[text];
                    tag.classList.add("translated");
                    attachLoadMoreListener()
                }
            });
            typeToTranslate.forEach(type => {
                const text = type.innerText.trim();
                if (typeTranslations[text]) {
                    type.innerText = typeTranslations[text];
                    type.classList.add("translated");
                }
            });
            colorToTranslate.forEach(color => {
                const text = color.getAttribute("title").trim();
                if (colorTranslations[text]) {
                    color.setAttribute('title', colorTranslations[text]);
                }
            });
        }
         if (colorTooltipToTranslate.length > 0 && typeCardToTranslate.length > 0){

            colorTooltipToTranslate.forEach(color => {
                const text = color.innerHTML.trim();
                if (colorTranslations[text]) {
                    color.innerHTML = colorTranslations[text];
                }
            });
            typeCardToTranslate.forEach(type => {
                const text = type.innerText.trim();
                if (typeTranslations[text]) {
                    type.innerText = typeTranslations[text];
                }
            });
        } 
        if (attempts < maxAttempts) {
            // Not found yet, try again
            attempts++;
            setTimeout(attemptTranslation, 500);
        } else {
            console.log("Max attempts reached, labels not found");
        }
    }

    attemptTranslation();
}


// Add event listener to Load More button with retry logic
function attachLoadMoreListener() {
    let attempts = 0;
    const maxAttempts = 7;

    function attemptAttach() {
        const loadMoreBtn = document.querySelector('.snize-search-results .snize-pagination .snize-pagination-load-more');
        
        if (loadMoreBtn && !loadMoreBtn.hasAttribute('data-translate-listener')) {
            // Found button and hasn't been set up yet
            loadMoreBtn.addEventListener('click', function() {
                console.log('Load More clicked');
                // Small delay to let new products load
                setTimeout(translateTags, 1000);
            });
            
            // Mark that we've added the listener to avoid duplicates
            loadMoreBtn.setAttribute('data-translate-listener', 'true');
            console.log('Load More listener attached successfully');
            
        } else if (!loadMoreBtn && attempts < maxAttempts) {
            // Button not found yet, try again
            attempts++;
            setTimeout(attemptAttach, 500);
        } else if (attempts >= maxAttempts) {
            console.log("Max attach attempts reached, Load More button not found");
        }
    }

    attemptAttach();
}

document.addEventListener("DOMContentLoaded", setBrandHover);
document.addEventListener("DOMContentLoaded", moveDisponibilityButton);
document.addEventListener("DOMContentLoaded", addContainerSubMenu);
document.addEventListener("DOMContentLoaded", () => setTimeout(translateTags, 1000));
document.addEventListener("DOMContentLoaded", () => setTimeout(translateTags, 2000));

// Hook into Searchanise events for filter clicks and updates
document.addEventListener('Searchanise.Loaded', function() {
    (function($) {
        
        // When data is received (filters, search, pagination)
        $(document).on('Searchanise.DataRequestEnd', function(e, type, params, data) {
            console.log('Searchanise.DataRequestEnd triggered, type:', type);
            setTimeout(translateTags, 300);
        });
        
        // When results are rendered
        $(document).on('Searchanise.RenderResults', function(e) {
            console.log('Searchanise.RenderResults triggered');
            translateTags();
        });
        
        // When products are updated
        $(document).on('Searchanise.UpdateProducts', function(e) {
            console.log('Searchanise.UpdateProducts triggered');
            translateTags();
        });
        
        // Re-attach load more listener after updates
        $(document).on('Searchanise.RenderResults', function(e) {
            attachLoadMoreListener();
        });
        
    })(window.Searchanise.$);
});

(function () {
  const wrapper = document.querySelector('.m-menu-customer__wrapper');
  if (!wrapper) return;

  const label = wrapper.querySelector('.m-menu-customer__label');
  if (!label) return;

  // Make the label look and behave like a toggle button
  label.style.cssText = `
    display: flex; align-items: center; justify-content: space-between;
    width: 100%; padding: 16px 20px 16px 16px;
    cursor: pointer;
    border-top: 1px solid #e0e0e0;
  `;

// Add a chevron indicator
  const style = document.createElement('style');
  style.textContent = `
    .m-menu-customer__label .chevron::before {
      content: "\\f107" !important;
      font: 22px / 1 GloboMenuBaseIcon !important;
    }
  `;
  document.head.appendChild(style);

  const chevron = document.createElement('span');
  chevron.classList.add('chevron');
  chevron.style.transition = 'transform 0.3s ease';
  chevron.setAttribute('aria-hidden', 'true');
  label.appendChild(chevron);

  // Collect everything inside the wrapper except the label itself
  const contents = Array.from(wrapper.children).filter(el => el !== label);

  // Wrap them in a collapsible container
  const collapsible = document.createElement('div');
  collapsible.style.cssText = `
    overflow: hidden;
    max-height: 0;
    opacity: 0;
    transition: max-height 0.3s ease, opacity 0.2s;
  `;
  contents.forEach(el => collapsible.appendChild(el));
  wrapper.appendChild(collapsible);

  label.addEventListener('click', () => {
    const isOpen = collapsible.style.maxHeight !== '0px' && collapsible.style.maxHeight !== '';
    if (isOpen) {
      collapsible.style.maxHeight = '0';
      collapsible.style.opacity = '0';
      chevron.style.transform = 'rotate(0deg)';
    } else {
      collapsible.style.maxHeight = collapsible.scrollHeight + 'px';
      collapsible.style.opacity = '1';
      chevron.style.transform = 'rotate(180deg)';
    }
  });
})();
    /*---------------------------- Si on veut modifier les color swatches sur les pages de collection/recherche ----------------------------*/

    document.addEventListener('click', async function(e) {
      const colorSwatch = e.target.closest('.snize-color-swatch');
      if (!colorSwatch) return;

      const item = colorSwatch.closest('.snize-item');
      if (!item) return;

      const selectedColor = colorSwatch.dataset.value;

      const link = item.closest('a.snize-view-link');
      const match = link?.href.match(/\/products\/([^?]+)/);
      if (!match) return;

      const handle = match[1];

      const res = await fetch(`/products/${handle}.json`);
      const data = await res.json();

      const firstMatch = data.product.variants.find(v => v.option1 === selectedColor);

      if (!firstMatch) return;

      const targetSize = String(firstMatch.option2);

      const sizeInput = item.querySelector('.snize-option-size');
      if (sizeInput) {
        sizeInput.value = targetSize;
        sizeInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      const matchingSize = [...item.querySelectorAll('.snize-size')]
        .find(s => s.dataset.value === targetSize);

      if (matchingSize) {
        matchingSize.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
      }

    }, true);  